var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_189","data-name":"Path 189","d":"M39.822,5.814a.405.405,0,0,0-.3-.138H36.465V4.533c0-.227.049-.487.414-.487h2.433a.357.357,0,0,0,.284-.122.405.405,0,0,0,.114-.276V.405A.405.405,0,0,0,39.3,0H35.792C31.9,0,31.6,3.325,31.6,4.339V5.677H29.572a.405.405,0,0,0-.405.405V9.326a.405.405,0,0,0,.405.405H31.6v9.326a.405.405,0,0,0,.405.405H36.06a.405.405,0,0,0,.405-.405V9.731h2.717a.405.405,0,0,0,.405-.365l.341-3.244A.405.405,0,0,0,39.822,5.814Z","transform":"translate(-29.167)","fill":"#707070"}));
}

Facebook.defaultProps = {"width":"10.763","height":"19.463","viewBox":"0 0 10.763 19.463"};

module.exports = Facebook;

Facebook.default = Facebook;
